import { z } from 'zod'
import { contractDocumentStatusSchema, contractTemplateTypeSchema } from '@super-mega/server/contracts/contract'

export const contractDocumentSearchSchema = z.object({
  current: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce.number().int().min(1).max(100).catch(20),
  keyword: z.coerce.string().trim().max(255).optional().catch(undefined),
  id: z.coerce.number().int().positive().optional().catch(undefined),
  type: contractTemplateTypeSchema.optional().catch(undefined),
  status: contractDocumentStatusSchema.optional().catch(undefined)
})
export type ContractDocumentSearch = z.infer<typeof contractDocumentSearchSchema>
